import { Fragment, Suspense, useEffect, lazy } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

// Lazy-loaded views
// RootLayout
import Loading from "./components/placeholder/Loading";
import { ROUTES } from "./constant/routes";
import RootLayout from "./components/layouts/RootLayout";
// Lazy-loaded views
const HomeView = lazy(() => import("./views/HomeView"));
const PricingView = lazy(() => import("./views/PricingView"));
const AboutView = lazy(() => import("./views/AboutView"));
const ChecklistView = lazy(() => import("./views/ChecklistView"));
const PortfolioView = lazy(() => import("./views/PortfolioView"));
const ContactView = lazy(() => import("./views/ContactView"));
const PrivacyPolicy = lazy(() => import("./views/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./views/TermsOfService"));


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Fragment>
      <ScrollToTop />

      <Suspense fallback={<Loading />}>
        <Routes>
          <Route element={<RootLayout />}>
            <Route path={ROUTES.HOME} element={<HomeView />} />
            <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />
            <Route
              path={ROUTES.TERMS_OF_SERVICE}
              element={<TermsOfService />}
            />
            <Route path={ROUTES.CONTACT} element={<ContactView />} />
            <Route path={ROUTES.PORTFOLIO} element={<PortfolioView />} />
            <Route path={ROUTES.CHECKLIST} element={<ChecklistView />} />
            <Route path={ROUTES.ABOUT} element={<AboutView />} />
            <Route path={ROUTES.PRICING} element={<PricingView />} />
          </Route>
        </Routes>
      </Suspense>
    </Fragment>
  );
}

export default App;
